import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  applyUserCoupon,
} from './coupon.api';
import { Cart } from '../../models/cart.types';

export const useApplyUserCouponMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (
      { couponCode, cart }: { couponCode: string; cart: Cart },
    ) => applyUserCoupon(couponCode, cart),

    onSuccess: (recalculatedCart) => {
      queryClient.invalidateQueries({ queryKey: ['cartItems'] });
      return recalculatedCart;
    },
  });
};
